/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui';
import { hoverTransition } from '../../../../../utils/styles/general';



/* ++++++++++ --------------- MENU : STYLES --------------- ++++++++++ */
export default {
	menu: {
		width: pxToEm(200),
		height: 'auto',
		background: 'rgb(255, 255, 255)',
		boxShadow: replacePXinStringWithEM(`0px 2px 5px 0px rgba(36, 78, 185, 0.1), 0px 0px 5px 0px rgba(172, 217, 251, 0.2)`),
		borderRadius: pxToEm(8),
		opacity: '0',
		position: 'absolute',
		right: '100%',
		extend: hoverTransition('box-shadow'),
		'&:hover': {
			boxShadow: replacePXinStringWithEM(`0px 2px 5px 0px rgba(36, 78, 185, 0.1), 0px 0px 5px 0px rgba(172, 217, 251, 0.7)`)
		},
		'&.userMenuOpen': {
			'&-true': {
	        	animationName: 'fadeIn',
	            animationDuration: '.05s',
	            animationFillMode: 'forwards',
	            animationDelay: '0s',
	            right: pxToEm(-200)
			},
			'&-false': {
				animationName: 'fadeOut',
	            animationDuration: '.05s',
	            animationFillMode: 'forwards',
	            animationDelay: '0s'
			}
		}
	}
}; 